module.exports = __webpack_public_path__ + "static/7-2be775be82e49e5864d72372a622d4c9.jpg";